<script>
import { mapGetters } from 'vuex'
import PaymentForm from '@/components/PaymentForm/PaymentForm.vue'
import { getCurrency } from '@/utils/format'
import { getPciDssPaymentTokens, submitPostpaidPayment } from '@/api/ads'
import { formatNumber } from '@/views/ads/utils/index'
import { PAYMENT_METHODS } from '@/views/ads/constants/payments'

export default {
  name: 'PciDssPaymentForm',
  components: {
    PaymentForm,
  },
  computed: {
    ...mapGetters('ads', ['paymentData']),
    currency() {
      return this.paymentData?.billingAddress?.currency || ''
    },
    amount() {
      return formatNumber(this.paymentData?.amount || 0)
    },
    payButtonText() {
      return `${this.$t('ads_postpaid_pay')} ${getCurrency(this.currency)} ${
        this.amount
      }`
    },
  },
  methods: {
    onCancel() {
      if (
        this.$route?.meta?.prevRoute?.path?.includes('ads/postpaid/invoice')
      ) {
        this.$router.go('-1')
      } else {
        this.$router.replace('/ads/postpaid/invoice/')
      }
    },
    async onPay({ cardNumber, expiryMonth, expiryYear, cvv, paymentData }) {
      // Get PCI DSS payment tokens
      const pciDssPaymentTokensRes = await getPciDssPaymentTokens({
        number: cardNumber.replace(/\s/g, ''),
        expiryMonth: Number(expiryMonth),
        expiryYear: Number(expiryYear),
        cvv: cvv,
      })

      const { token, bin } = pciDssPaymentTokensRes.data

      // Create ads credit payment
      const adsCreditPaymentRes = await submitPostpaidPayment({
        bin,
        cardToken: token,
        paymentMethod: PAYMENT_METHODS.TAMARA_PAY_CARD,
        invoiceId: paymentData.invoiceId,
      })

      const { data } = adsCreditPaymentRes.data

      // Redirect
      if (data && data.redirectUrl) {
        window.location.href = data.redirectUrl
      } else {
        this.$router.push('/ads/postpaid/failure')
      }
    },
    getCurrency,
  },
}
</script>

<template>
  <PaymentForm
    :on-cancel="onCancel"
    :on-pay="onPay"
    :pay-button-text="payButtonText"
  />
</template>
